import React, { useState } from 'react';
// Make sure this path is correct for your project structure
import '../Assets/scss/components/progressiveimage.scss';

// The props are now simpler, extending standard image attributes
interface ProgressiveImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
}

const ProgressiveImage: React.FC<ProgressiveImageProps> = ({ src, alt, ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="progressive-image-wrapper">
      <img
        {...{ src, alt, ...props }}
        // The onLoad event tells us when the image has finished downloading
        onLoad={() => setIsLoaded(true)}
        // Conditionally apply a class based on the loaded state
        className={`progressive-image ${isLoaded ? 'loaded' : 'loading'}`}
      />
    </div>
  );
};

export default ProgressiveImage;